import Map from '../../../components/Map';

const LinhaTempoMap = () => <Map mapContainerClassName="h-full" />;

export default LinhaTempoMap;
